import { Component, Input, OnInit } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { Client, ContractStatus, Parking, Plan, Subscription, SubscriptionType, Term, EnumNames, UserActionLog } from '@parkupp/core'
import { User } from 'firebase/auth'
import { serverTimestamp } from 'firebase/firestore'
import * as moment from 'moment'
import { AuthenticationService } from 'src/app/services/authentication.service'
import { ClientService } from 'src/app/services/client.service'
import { GlobalService } from 'src/app/services/global.service'
import * as firestore from 'firebase/firestore'
import { SubscriptionService } from 'src/app/services/subscription.service'
import { ParkingService } from 'src/app/services/parking.service'
import { Router } from '@angular/router'

@Component({
    selector: 'app-payfast-booking-form',
    templateUrl: './payfast-booking-form.component.html',
    styleUrls: ['./payfast-booking-form.component.scss'],
})
export class PayfastBookingFormComponent implements OnInit {
    EnumNames = EnumNames
    @Input() parking: Parking
    @Input() inputSubscriptionType: SubscriptionType
    // @Input() selectedPlan: ParkingPlan

    formData = new FormGroup({
        // planTerm: new FormControl(null, [Validators.required]),
        baysBooked: new FormControl(1, [Validators.required, Validators.min(1)]),
        startDate: new FormControl(moment().format('yyyy-MM-DD'), [Validators.required]),
        endDate: new FormControl({ value: moment().add(1, 'M').subtract(1, 'd').format('yyyy-MM-DD'), readonly: true }, [Validators.required]),
        contractLength: new FormControl(1, [Validators.required, Validators.min(1)]),
    })

    user: User
    profile: Client | null
    formError: string | null = null
    formLoading: boolean = false
    selectedPlan: Plan

    landlordLeaseAgreementAccepted = true
    landlordUsePolicyAccepted = true
    parkUppTermsAccepted = true

    constructor(
        private authenticationService: AuthenticationService,
        private clientService: ClientService,
        public globalService: GlobalService,
        private parkingService: ParkingService,
        private subscriptionService: SubscriptionService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.user = await this.authenticationService.waitForUid()
        this.profile = await this.clientService.getClientByUid(this.user.uid)

        console.log(this.parking)

        this.selectedPlan = this.parking.plans?.find((i) => i.term === Term.MONTHLY) as Plan

        this.formData.controls['startDate'].valueChanges.subscribe((value) => this.formChanges({ startDate: value }))
        this.formData.controls['contractLength'].valueChanges.subscribe((value) => this.formChanges({ contractLength: value }))
        this.updateEndDate(this.selectedPlan.term, this.formData.value.startDate, 1)
    }

    formChanges(changes: { startDate?: string; contractLength?: number }) {
        let startDate = changes.startDate ? changes.startDate : this.formData.value.startDate
        this.updateEndDate(this.selectedPlan.term, startDate, changes.contractLength || this.formData.value.contractLength)
    }

    updateEndDate(term: string, startDate: Date, contractLength: any) {
        const lengthUnit = term == Term.MONTHLY ? 'M' : 'd'
        const newEndDate = moment(startDate).add(contractLength, lengthUnit).subtract(1, 'day').format('yyyy-MM-DD')

        this.formData.controls['endDate']?.setValue(newEndDate)
    }

    async createSubscription() {
        this.formLoading = true

        // if (this.subscription.period > 1) {
        //     let startDate = new Date(this.formData.value.startDate)
        //     // startDate.setDate(startDate.getDate() + 30)
        //     // this.subscription.nextDebitDate = firestore.Timestamp.fromDate(startDate)
        //     this.subscription.nextDebitDate = firestore.Timestamp.fromDate(startDate)
        // }

        const subscription = new Subscription()
        if (this.inputSubscriptionType === SubscriptionType.PAYFAST) {
            subscription.type = SubscriptionType.PAYFAST
        } else if (this.inputSubscriptionType === SubscriptionType.EFT) {
            subscription.type = SubscriptionType.EFT
        }
        subscription.denormClientFirstName = this.profile?.firstName || ''
        subscription.denormClientLastName = this.profile?.lastName || ''
        subscription.denormParkingTitle = this.parking.title
        subscription.denormMerchantCompanyName = this.parking.denormMerchantCompanyName

        const now = serverTimestamp() as firestore.Timestamp

        subscription.createdAt = now
        subscription.updatedAt = now

        const client = await this.clientService.getClientByUid(this.user.uid)

        subscription.clientRef = this.clientService.getDocRef(this.profile?.$key!) as any
        subscription.parkingRef = this.parkingService.getDocRef(this.parking.$key!) as any

        subscription.plan = new Plan(this.selectedPlan)

        subscription.period = this.formData.value.contractLength
        subscription.baysBooked = this.formData.value.baysBooked

        const startDateObject = new Date(this.formData.value.startDate)
        subscription.startDate = firestore.Timestamp.fromDate(startDateObject)
        subscription.nextDebitDate = firestore.Timestamp.fromDate(startDateObject)

        const endDateObject = new Date(this.formData.value.endDate)
        subscription.endDate = firestore.Timestamp.fromDate(endDateObject)

        subscription.merchantRef = this.parking.merchantRef
        subscription.status = ContractStatus.paymentInitiated

        const ip = await GlobalService.getPublicIP()
        const userActionLog = new UserActionLog({
            firstName: client?.firstName,
            lastName: client?.lastName,
            email: client?.$email,
            mobile: client?.$phoneNumber,
            ip: ip,
            agent: navigator.userAgent,
            date: now,
        })

        subscription.contractCreationLog = userActionLog

        const response = await this.subscriptionService.create(subscription)

        this.formLoading = false

        await this.router.navigate(['/client', this.profile?.$key])
    }

    getButtonText() {
        if (this.inputSubscriptionType === SubscriptionType.PAYFAST) {
            return 'Create parking request with PayFast Invoicing'
        } else if (this.inputSubscriptionType === SubscriptionType.EFT) {
            return 'Create parking request with EFT Invoicing'
        }
        return 'Create parking request'
    }

    toggleLandlordUsePolicyAccepted() {
        this.landlordUsePolicyAccepted = !this.landlordUsePolicyAccepted
    }

    toggleParkUppTermsAccepted() {
        this.parkUppTermsAccepted = !this.parkUppTermsAccepted
    }

    toggleLandlordLeaseAgreementAccepted() {
        this.landlordLeaseAgreementAccepted = !this.landlordLeaseAgreementAccepted
    }
}
